<template>
  <a-modal
    class="create-evaluation-modal"
    :width="650"
    title="发布测评"
    :visible="visible"
    :footer="null"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <div>
      <template v-if="current == 1">
        <a-form-model
          ref="ruleForm"
          :labelCol="{ span: 4 }"
          :wrapperCol="{ span: 19 }"
          :model="form"
          :rules="rules"
        >
          <a-form-model-item label="选择量表" prop="evaluationIds">
            <a-select
              show-search
              mode="multiple"
              v-model="form.evaluationIds"
              option-filter-prop="children"
              :filter-option="filterOption"
              :options="evalOptions"
              placeholder="请选择量表"
            />
          </a-form-model-item>
          <a-form-model-item label="测评标题" prop="name">
            <a-input v-model="form.name" placeholder="请输入测评标题" />
          </a-form-model-item>
          <a-form-model-item label="测评时间" prop="dateRang">
            <a-range-picker
              v-model="form.dateRang"
              style="width: 100%"
              :disabledDate="(currentDate) => disabledEndDate(currentDate, form.dateRang)"
            />
          </a-form-model-item>
          <a-form-model-item label="测评范围" prop="gradeIds">
            <j-multi-select-tag
              style="width: 48%; margin-right: 4%"
              placeholder="请选择年级"
              :isHasAll="true"
              v-model="form.gradeIds"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :allowClear="false"
              :isShowEmpty="false"
              @select="selectGrade"
            />
            <j-multi-select-tag
              style="width: 48%"
              placeholder="请选择班级"
              :isHasAll="true"
              v-model="form.classIds"
              :dictCode="
                'school_class,name,id,grade_id=' + (!form.gradeId ? -1 : form.gradeId)
              "
              :async="true"
              :disabled="!form.gradeIds"
              :isShowEmpty="false"
              @select="selectClass"
            />
          </a-form-model-item>
          <a-form-model-item label="测评方式" prop="evaluationMethod">
            <j-dict-select-tag
              v-model="form.evaluationMethod"
              placeholder="请选择测评方式"
              dictCode="evaluation_method"
            />
          </a-form-model-item>
        </a-form-model>
      </template>
      <template v-else-if="current == 2">
        <div>
          <div>
            测评创建后，需要心理老师或年级主任组织各班负责人安排学生在规定时间内到机房参与测评
          </div>
          <div>
            1、 学生必须在测评起止时间内完成，否则学生的测评结果将不会被记录。
            <br />
            2、 在测评起止时间内老师可以更改测评结束时间，超过结束时间则无法更改。
            <br />
            3、 每个测评所需要的答题时间不同，请老师根据每个测评的答题建议时长来组织安排。
            <br />
            4、
            每个班级需要至少一名负责老师组织安排学生开始测评，并负责回答学生在测评时所提出的问题。
            <br />
            5、
            建议在大规模测评前，对各班负责人统一组织培训，并确保每位负责人理解测评目的并懂得如何施测。
            <br />
            6、
            建议测评在一个光线充足的房间中进行的，如果可能的话，需要提前检查房间的空调，保证房间的温度和湿度在一定可控范围内，否则可能会影响测评结果
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <a-result status="success" sub-title="测评已发布成功，复制链接，打开后学生即可进入测评">
            <template #title>
              <div>发布成功</div>
            </template>
            <template #extra>
              <div class="flex-between">
                <a-input type="text" v-model="textToCopy" />
                <a style="display: inline-block; width: 100px" @click="copyText">复制链接</a>
              </div>
            </template>
          </a-result>
        </div>
      </template>
      <div slot="footer" class="flex-align-center" style="justify-content: end">
        <a-button @click="handleCancel">
          {{ current < 3 ? '取消' : '查看详情' }}
        </a-button>
        <a-button
          type="primary"
          :loading="isSubmitting"
          style="margin: 0 22px 0 15px"
          @click="handleOk"
        >
          {{ isEdit ? '确定' : current == 1 ? '下一步' : current == 2 ? '提交测评' : '再发布一个' }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { getAction, postAction } from '@api/manage'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'
import { TOPIC_RECORD } from '@/store/mutation-types'
import Vue from 'vue'
import { disabledEndDate } from '@/utils/date'

export default {
  name: 'CreateEvaluation',
  components: {
    JMultiSelectTag,
  },
  data() {
    return {
      visible: false,
      current: 1,
      evalOptions: [], // 量表列表
      form: {},
      textToCopy:
        window.location.origin + '/#/school/mentalHealth/StudentAnswer/index',
      evaluatRecord: {},
      rules: {
        evaluationIds: [{ required: true, message: '请选择量表', trigger: 'change' }],
        name: [{ required: true, message: '请输入测评标题', trigger: 'change' }],
        gradeIds: [{ required: true, message: '请选择年级', trigger: 'blur' }],
        dateRang: [{ required: true, message: '请选择日期范围', trigger: 'change' }],
        evaluationMethod: [{ required: true, message: '请选择测评方式', trigger: 'blur' }],
      },
      submitStatus: false,
      isEdit: false, // 是否为编辑状态
      allGradeIds: '',
      allClassIds: '',
      isSubmitting: false, // 是否在提交测评
    }
  },
  methods: {
    disabledEndDate,
    showModal(data, index) {
      console.log('编辑信息：', data)
      if (data) {
        this.form = {
          ...data,
          evaluationIds: data.evaluationIds?.split(','),
          dateRang: [data.beginDate, data.endDate],
        }
        console.log('年级信息：', this.form.gradeIds)
        this.isEdit = true
      } else {
        this.form = {}
        this.isEdit = false
      }
      // console.log('数据：', data)
      this.visible = true
      this.getEvaluationList()
    },
    // 获取量表列表
    async getEvaluationList() {
      const res = await getAction('/schoolEvaluation/list', { pageNo: 1, pageSize: 500 })
      const { success, result } = res
      if (success) {
        this.evalOptions = result.records.map((item) => ({
          value: item.id,
          label: item.name,
        }))
      }
    },
    hideModal() {
      this.visible = false
      this.current = 1
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async handleOk() {
      const params = {
        id: this.form.id,
        evaluationIds: Array.isArray(this.form.evaluationIds)
          ? this.form.evaluationIds.join(',')
          : this.form.evaluationIds,
        name: this.form.name,
        gradeIds: this.allGradeIds || this.form.gradeIds,
        classIds: this.allClassIds || this.form.classIds,
        evaluationMethod: this.form.evaluationMethod,
        beginDate: moment(this.form.dateRang?.[0]).format('YYYY-MM-DD'),
        endDate: moment(this.form.dateRang?.[1]).format('YYYY-MM-DD'),
      }
      if (this.current == 1) {
        this.$refs.ruleForm.validate(async (valid) => {
          this.submitStatus = valid
        })
        if (!this.submitStatus) return
        if (this.isEdit) {
          const res = await postAction('/schoolEvaluationPlan/edit', params)
          if (res.success) {
            this.$message.success('编辑测评计划成功')
            this.$emit('refreshTable')
          } else {
            this.$message.error('编辑测评计划失败')
          }
          this.hideModal()
          return
        }
      } else if (this.current == 2) {
        this.isSubmitting = true
        const res = await postAction('/schoolEvaluationPlan/add', params)
        if (res.success) {
          this.$message.success('创建测评计划成功')
          Vue.ls.set(TOPIC_RECORD, { queryRecord: res.result })
          this.$emit('refreshTable')
        } else {
          this.$message.error('创建测评计划失败')
        }
        this.isSubmitting = false
      }
      this.current = this.current + 1
      if (this.current > 3) {
        this.current = 1
        this.form = {}
      }
    },
    handleCancel() {
      if (this.current == 3) {
        this.$emit('changeTab')
        const route = this.$router.resolve({ path: '/school/mentalHealth/StudentAnswer/index' })
        window.open(route.href, '_blank')
      }
      this.hideModal()
    },
    selectGrade(data) {
      if (data.val === 'all') {
        this.$set(this.form, 'gradeIds', data.val)
        this.allGradeIds =
          data.dictOptions.length > 0 ? data.dictOptions.map((item) => item.id).join(',') : ''
      } else {
        this.allGradeIds = ''
      }
      this.$set(this.form, 'classIds', undefined)
    },
    selectClass(data) {
      if (data.val === 'all') {
        this.allClassIds =
          data.dictOptions.length > 0 ? data.dictOptions.map((item) => item.id).join(',') : ''
      } else {
        this.allClassIds = ''
      }
    },
    copyText() {
      // 使用现代剪贴板API
      navigator.clipboard
        .writeText(this.textToCopy)
        .then(() => {
          this.$message.success('复制链接成功')
        })
        .catch((err) => {
          this.$message.error('复制链接失败')
        })
    },
  },
}
</script>
<style scoped lang="less">
.create-evaluation-modal {
  /deep/ .ant-result {
    padding: 20px 32px;
  }
  /deep/ .ant-result-icon {
    margin-bottom: 10px;
    svg {
      color: #1783e8 !important;
    }
  }
  /deep/ .ant-result-title {
    font-size: 20px;
    font-weight: bold;
  }
  /deep/ .ant-result-subtitle {
    margin-top: 10px;
  }
}
</style>
